import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-down', 'IconChevronDown', [
  ['path', { d: 'M6 9l6 6l6 -6', key: 'svg-0' }],
]);
